// import '@/libs/tour'
import '@/libs/acl'
import '@/libs/clipboard'
import '@/libs/portal-vue'
import '@/libs/sweet-alerts'
import '@/libs/toastification'
import '@/libs/vue-select'
// 3rd party plugins
import '@axios'
import VueCompositionAPI from '@vue/composition-api'
import { ModalPlugin, ToastPlugin } from 'bootstrap-vue'
import Vue from 'vue'
import i18n from '@/libs/i18n'
import App from './App.vue'
// Global Components
import './global-components'
import router from './router'
import store from './store'
import './@core/styles/global.css'
import { setStoreAndRouter } from './@core/auth/jwt/jwtService'
import { setStore } from './composable/usePermission'
// Deployment Detection System
import deploymentDetector from '@/utils/deploymentDetector'
import inactivityManager from '@/utils/inactivityManager'
import '@/utils/crossTabLogoutTest'

// Exclude mock data from production builds
// eslint-disable-next-line global-require, import/first
if (process.env.NODE_ENV !== 'production') require('@/@fake-db/db')

setStore(store)
setStoreAndRouter(store, router)

// Expose inactivity manager globally for debugging (production-safe)
window.inactivityManager = inactivityManager

// Simple debug function (only when explicitly called)
// window.debugInactivityManager = () => {
//   console.log('Inactivity Manager Status:')
//   console.log('- Enabled:', inactivityManager.isEnabled)
//   console.log('- Duration:', inactivityManager.inactivityDuration / 1000, 'seconds')
//   console.log('- Warning Duration:', inactivityManager.warningDuration / 1000, 'seconds')
//   console.log('- Last Activity:', (Date.now() - inactivityManager.lastActivity) / 1000, 'seconds ago')
//   console.log('- Timer Info:', inactivityManager.timerInfo)
// }

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')
require('@/assets/scss/deployment-notifications.scss')

Vue.config.productionTip = false

// Vue global error handler for chunk loading errors
Vue.config.errorHandler = (err, vm, info) => {
  console.error('Vue error:', err, info)

  // Check if it's a chunk loading error
  if (
    err.message
    && (err.message.includes('Loading chunk')
     || err.message.includes('Loading CSS chunk')
     || err.message.includes('ChunkLoadError'))
  ) {
    console.log('Vue chunk loading failed - marking update as available...')

    // Just mark update as available, don't interrupt user flow
    deploymentDetector.setUpdateAvailable(true)
  }
}

// Global error handler for chunk loading failures
window.addEventListener('error', event => {
  const { message, filename } = event

  // Check if the error is related to chunk loading failure
  if (
    (message
    && (message.includes('Loading chunk')
     || message.includes('Loading CSS chunk')
     || message.includes('ChunkLoadError')))
    || (filename && filename.includes('chunk-'))
  ) {
    console.log('Chunk loading failed - likely due to new deployment. Marking update as available...')

    // Just mark update as available, don't interrupt user flow
    deploymentDetector.setUpdateAvailable(true)
  }
})

// Handle unhandled promise rejections (for dynamic imports)
window.addEventListener('unhandledrejection', event => {
  const error = event.reason

  if (
    error
    && error.message
    && (error.message.includes('Loading chunk')
     || error.message.includes('Loading CSS chunk')
     || error.message.includes('ChunkLoadError'))
  ) {
    console.log('Chunk loading promise rejected - likely due to new deployment. Marking update as available...')
    event.preventDefault() // Prevent the error from being logged

    // Just mark update as available, don't interrupt user flow
    deploymentDetector.setUpdateAvailable(true)
  }
})

// Initialize deployment detection
deploymentDetector.init()

// Initialize user's preferred font from localStorage
const savedFont = localStorage.getItem('preferredFont')
if (savedFont) {
  document.documentElement.style.setProperty(
    '--font-family-primary',
    `'${savedFont}', sans-serif`,
    'important',
  )
}

// Initialize user's preferred font scale from localStorage
const savedFontScale = parseInt(localStorage.getItem('fontScale'), 10) || 100
if (savedFontScale !== 100) {
  const baseSize = 16 * (savedFontScale / 100)
  document.documentElement.style.setProperty(
    '--font-size-base',
    `${baseSize}px`,
    'important',
  )
  document.documentElement.style.fontSize = `${baseSize}px`
}

// Initialize sidebar collapsed state from localStorage
const savedSidebarState = localStorage.getItem('sidebarCollapsed')
if (savedSidebarState !== null) {
  store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', savedSidebarState === 'true')
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
